import { ReservationFlowCustomerSubscriptionAvailableReservationCount } from '../../../../interfaces/reservation_flow';

// 購入済み月謝が予約回数によって制限されているかの判定
export const isRestrictedCustomerSubscriptionReservationCount: (
  availableReservationCount: ReservationFlowCustomerSubscriptionAvailableReservationCount,
) => boolean = (availableReservationCount) => {
  return Object.values(availableReservationCount.value).some((value) => {
    // nullは制限が設定されていない状態
    if (value === null) {
      return false;
    }

    // 制限されている場合は0が設定される
    return value === 0;
  });
};
